import { atom } from 'jotai';

export const maxTotalPriceAtom = atom('');
export const maxMonthlyPriceAtom = atom('');
